import { handleInvoiceReportForbiddenWithEarlyReturn } from '@/context/services/invoice_reports/handleInvoiceReportForbiddenStatusCode';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useGetTargetApplicantsForInvoiceReportsHook } from 'ap-openapi';
import { useCallback } from 'react';

/**
 * Returns an async function that checks if the current user has any proxy applicant targets.
 * Shows an error toast and returns false if none exist, returns true otherwise.
 * Uses per=1 to minimize API cost — we only need existence, not the full list.
 */
export function useCheckProxyApplicantPermission() {
  const getTargetApplicantsApi = useGetTargetApplicantsForInvoiceReportsHook();
  const notify = useToastAPI();

  return useCallback(
    async (errorMessage: string): Promise<boolean> => {
      try {
        const response = await getTargetApplicantsApi({
          display_all_roles: false,
          per: '1',
          page: '1',
        });

        if (handleInvoiceReportForbiddenWithEarlyReturn(response.status)) {
          return false;
        }

        const members = response.data.office_members;
        if (!members || members.length === 0) {
          notify.error({ title: errorMessage, duration: 3 });
          return false;
        }
        return true;
      } catch {
        notify.error({ title: errorMessage, duration: 3 });
        return false;
      }
    },
    [getTargetApplicantsApi, notify]
  );
}
